export default "/ARB.ffcaf324005e44aaee8f61a4b1faf67d.svg";